import { t } from '@lingui/core/macro';
import { Alert } from '@pocketlaw/tetris';
export function UpdateErrorAlert() {
    return (<Alert appearance="danger" title={t({
            message: 'Could not update project',
            comment: 'Edit project dialog - Error alert title',
        })} message={t({
            message: 'Something went wrong, please try again later.',
            comment: 'Edit project dialog - Error alert message',
        })}/>);
}
